import { getProductsDetail } from '@/actions/ecom/productsDetail';
import { getProductPrices } from '@/actions/ecom/productDetail';
import { MapType } from '@/types';
import is from './is';

const fetchAndMergeProductsWithPrice = async (searchResults: any[]) => {
  const ids: number[] = [];
  const materialIds: string[] = [];
  searchResults.forEach(({ id, materialId }: any) => {
    ids.push(id);
    materialIds.push(materialId);
  });

  const promises = [
    getProductsDetail({
      ids: ids.join(','),
      fields: 'plainName,materialId,productId,slug',
      populate: 'featuredTag,tags,dealTag,media,flags',
    }),
    getProductPrices(materialIds.join(',')),
  ];

  const [products, productPriceMap] = await Promise.all(promises);
  const productMaterialIdMap: MapType = {};
  if (is.not.empty.array(products)) {
    products.forEach((product: any) => {
      // Only keep one image
      if (is.not.empty.array(product.attributes.media.data)) {
        product.attributes.media.data = [product.attributes.media.data[0]];
      }
      productMaterialIdMap[product.attributes.materialId] = product;
    });
  }

  return searchResults?.map(({ materialId }: any) => {
    const product: MapType = {};
    product.price = productPriceMap[materialId] ?? null;
    if (productMaterialIdMap[materialId]) {
      Object.assign(product, { ...productMaterialIdMap[materialId] });
    }
    return product;
  });
};

export default fetchAndMergeProductsWithPrice;
